import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppContext } from '@/Main';
import { Dropdown } from 'react-bootstrap';
import type { RefObject, ReactNode } from 'react';
import type ReactEChartsCore from 'echarts-for-react/lib/core';

interface CardChartDropDownProps {
  cardRef: RefObject<HTMLElement | null>;
  chartRef: RefObject<ReactEChartsCore | null>;
  otherDropDowns?: ReactNode;
}

const CardChartDropDown = ({
  cardRef,
  chartRef,
  otherDropDowns = null,
}: CardChartDropDownProps) => {
  const {
    config: { isDark },
  } = useAppContext();

  return (
    <Dropdown align="end" className="btn-reveal-trigger d-inline-block me-0">
      <Dropdown.Toggle
        className="text-600 btn-reveal"
        split
        variant="reveal"
        size="sm"
      >
        <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="border py-0">
        {otherDropDowns}
        <Dropdown.Item
          onClick={() => {
            const dataURL = chartRef.current
              ?.getEchartsInstance()
              ?.getDataURL({
                type: 'png',
                pixelRatio: 1,
                backgroundColor: isDark ? '#121E2D' : '#fff',
              });
            if (!dataURL) return;

            const link = document.createElement('a');
            link.href = dataURL;
            link.setAttribute('download', 'chart-from-Mizfa-Tools.png');
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}
          className="link-600 fs--1 d-flex align-items-center gap-1 py-1"
        >
          ذخیره تصویر
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => {
            cardRef.current?.requestFullscreen();
          }}
          className="link-600 d-none d-md-flex fs--1 align-items-center gap-1 py-1"
        >
          تمام صفحه
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CardChartDropDown;
